import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function bindCompareCheckboxes(root = document) {
    const compareBoxes = root.querySelectorAll("input[name='compare']");

    compareBoxes.forEach(cb => {
        if (cb.dataset.compareBound) return;
        cb.dataset.compareBound = true;
        cb.addEventListener("change", () => {
            const { checked, dataset } = cb;
            window.dispatchEvent(
                new CustomEvent("compare-toggle", {
                    detail: { ...dataset, checked }
                })
            );
        });
    });

    window.addEventListener("compare-toggle", (e) => {
        const { code, checked } = e.detail;
        const checkbox = root.querySelector(`input[name='compare'][data-code="${code}"]`);
        if (checkbox && checkbox.checked !== checked) {
            checkbox.checked = checked;
        }
    });
}



export function initCollectionsItems(root = document) {
    root.querySelectorAll('.tmp-collections-details__variant-carousel').forEach(function (carousel) {
        if (carousel.classList.contains('is-initialized')) return;

        const swiperEl = carousel.querySelector('.swiper');
        const prevBtn = carousel.querySelector('.swiper-button-prev');
        const nextBtn = carousel.querySelector('.swiper-button-next');

        if (swiperEl.swiper) {
            swiperEl.swiper.destroy(true, true);
        }

        new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
        });

        carousel.querySelectorAll('.tmp-collections-details__variant-image').forEach(img => {
            img.addEventListener('click', () => {
                const newUrl = img.dataset.contentUrl;
                const newSrc = img.dataset.mainSrc || img.currentSrc || img.src;
                const newSrcset = Object.prototype.hasOwnProperty.call(img.dataset, 'mainSrcset') ? img.dataset.mainSrcset : undefined;
                const newSizes = Object.prototype.hasOwnProperty.call(img.dataset, 'mainSizes') ? img.dataset.mainSizes : undefined;
                const newStyle = Object.prototype.hasOwnProperty.call(img.dataset, 'mainStyle') ? img.dataset.mainStyle : undefined;
                const newXpressFlag = img.dataset.mainXpress ?? 'False'; // note: this is using .net's bool string representation
                const itemRoot = carousel.closest('.tmp-collections-details__item');
                const itemBadges = itemRoot.querySelector('.tmp-collections-details__badges');
                const mainImage = itemRoot.querySelector('#tmpCollectionsDisplayedImage');
                
                if (itemBadges) {
                    itemBadges.setAttribute('data-xpress-visible', newXpressFlag);
                }

                const mainImageLink = itemRoot.querySelector('.tmp-collections-details__main-link');
                if (mainImageLink && newUrl) {
                    mainImageLink.href = newUrl;
                }

                if (mainImage && newSrc) {
                    if (newSrcset !== undefined) {
                        if (newSrcset) {
                            mainImage.setAttribute('srcset', newSrcset);
                        } else {
                            mainImage.removeAttribute('srcset');
                        }
                    }

                    if (newSizes !== undefined) {
                        if (newSizes) {
                            mainImage.setAttribute('sizes', newSizes);
                        } else {
                            mainImage.removeAttribute('sizes');
                        }
                    }

                    if (newStyle !== undefined) {
                        if (newStyle) {
                            mainImage.setAttribute('style', newStyle);
                        } else {
                            mainImage.removeAttribute('style');
                        }
                    }

                    mainImage.src = newSrc;
                    if (img.dataset.mcAssetType) {
                        mainImage.dataset.mcAssetType = img.dataset.mcAssetType;
                    }

                    if (img.dataset.mcProjectBoardAssetInfo) {
                        mainImage.dataset.mcProjectBoardAssetInfo = img.dataset.mcProjectBoardAssetInfo;
                    }
                }

                const variantName = img.alt;
                const variantNameEl = itemRoot.querySelector('.selected-variant-name');
                if (variantNameEl) {
                    variantNameEl.textContent = variantName;
                }

                if (mainImage && variantName) {
                    mainImage.alt = variantName;
                }

                const allWrappers = carousel.querySelectorAll('.tmp-collections-details__variant-image-wrapper');
                allWrappers.forEach(wrapper => wrapper.classList.remove('selected'));

                const clickedWrapper = img.closest('.tmp-collections-details__variant-image-wrapper');
                if (clickedWrapper) {
                    clickedWrapper.classList.add('selected');
                }

                const compareCb = itemRoot.querySelector("input[name='compare']");
                if (compareCb && newSrc) {
                    compareCb.dataset.img = newSrc;

                    if (compareCb.checked) {
                        window.dispatchEvent(
                            new CustomEvent("compare-toggle", {
                                detail: {
                                    img: newSrc,
                                    productCode: compareCb.dataset.code,
                                    checked: true
                                }
                            })
                        );
                    }
                }
            });
        });

        carousel.classList.add('is-initialized');
    });

    bindCompareCheckboxes(root);
}

document.addEventListener('DOMContentLoaded', () => {
    initCollectionsItems();
});

document.body.addEventListener('htmx:afterOnLoad', (e) => {
    initCollectionsItems(e.target);
});
